import React from 'react';
import { NavLink } from 'react-router-dom';
import './eligibility-criteria.css';
import {
  ScrollReveal,
  ScrollRevealStagger,
  ScrollRevealItem,
} from './ScrollReveal';

const criteriaList = [
  {
    title: 'Age 21 – 60 years',
    desc: 'You must be within this age range when applying.',
  },
  {
    title: 'Salaried or self-employed',
    desc: 'Stable corporate job or established business income.',
  },
  {
    title: 'Minimum income ₹50,000 / month',
    desc: 'Proven net monthly salary or consistent earnings.',
  },
  {
    title: 'Indian citizen with valid KYC',
    desc: 'PAN, Aadhaar, and address proof ready for verification.',
  },
];

const EligibilityCriteria = () => {
  return (
    <section className="elig-section" id="eligibility-criteria" aria-labelledby="elig-title">
      <div className="elig-bg" aria-hidden="true">
        <div className="elig-bg-gradient" />
        <div className="elig-bg-mesh" />
        <div className="elig-bg-dots" />
        <span className="elig-bg-orb elig-bg-orb--1" />
        <span className="elig-bg-orb elig-bg-orb--2" />
        <span className="elig-bg-orb elig-bg-orb--3" />
      </div>

      <div className="elig-wrap">
        <ScrollReveal className="elig-shell" y={44} duration={0.6}>
          <aside className="elig-visual" aria-label="Eligibility overview">
            <div className="elig-visual-bg" />
            <div className="elig-visual-overlay" />
            <div className="elig-visual-copy">
              <span className="elig-visual-tag">Quick check</span>
              <h2 id="elig-title" className="elig-visual-title">
                Who can
                <span> apply?</span>
              </h2>
              <p className="elig-visual-text">
                Four simple requirements for salaried professionals seeking an Ultra Short Term Loan.
              </p>
            </div>
          </aside>

          <div className="elig-main">
            <p className="elig-main-label">Eligibility criteria</p>

            <ScrollRevealStagger as="ul" className="elig-checklist" stagger={0.1}>
              {criteriaList.map((item) => (
                <ScrollRevealItem key={item.title} as="li" className="elig-check-item" y={24}>
                  <span className="elig-check-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>
                  <div className="elig-check-text">
                    <strong>{item.title}</strong>
                    <span>{item.desc}</span>
                  </div>
                </ScrollRevealItem>
              ))}
            </ScrollRevealStagger>

            <ScrollReveal delay={0.2} y={20}>
              <div className="elig-actions">
                <NavLink to="/apply-now" className="elig-btn elig-btn--fill">
                  Apply for loan
                </NavLink>
              </div>
            </ScrollReveal>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default EligibilityCriteria;
